import {SmartComponent} from "smart-component-js";
import CollectionPromoApi from "mbpromo/src/collection-api/CollectionPromoApi";
import Constants from "../business/Constants";
import Utility from "../business/Utility";
import GigyaManager from "../business/GigyaManager";
import AlertPuntiEstateComponent from "../components/AlertPuntiEstateComponent";

class DefaultCtrl extends SmartComponent {

	constructor(element, parentComponent, params) {
		super(element, parentComponent, params);
		if(element.getAttribute('id') === 'homepage') new AlertPuntiEstateComponent();

		this.chat = new Promise((resolve) => {
			// eslint-disable-next-line no-undef
			if (typeof window.$ec === undefined) {
				if (!window.checkIntervalChat) {
					window.checkIntervalChat = setInterval(function () {
						// eslint-disable-next-line no-undef
						if (window.$ec) {
							clearInterval(window.checkIntervalChat);
							resolve();
						}
					}, 500);
				}
			} else {
				return resolve();
			}
		});

		this.init();
		Utility.initProducts();
		Utility.enableHolidaysMessage();
		this.userLogged();
		this.collectionPromoApi = new CollectionPromoApi({promoCode: Constants.API_PROMOCODE});
	}

	isChatReady() {
		return this.chat;
	}

	userLogged() {
		GigyaManager.getLoggedUserCached().then((u) => {
			Utility.trackEvent(u.UID,"PAGE_VIEW");
			this.collectionPromoApi.areaPersonale(this.userToken).then((resp)=>{
				let body = resp.body;
				this.isChatReady().then(() => {
					if (!body.registrato) {
						// eslint-disable-next-line no-constant-condition,no-undef
						window.$ec.addUserInfo({promozione: Constants.TRACKING_PROMOCODE, pagecode: document.location.href, browserName: Utility.getDeviceInfo().browserName, browserVersione: Utility.getDeviceInfo().browserVersion, osName: Utility.getDeviceInfo().osName, osVersione: Utility.getDeviceInfo().osVersion, device: Utility.getDeviceInfo().device});
					} else {
						// eslint-disable-next-line no-constant-condition,no-undef
						window.$ec.addUserInfo({idGigya: resp.body.gigya_uid, promozione: Constants.TRACKING_PROMOCODE, pagecode: document.location.href, browserName: Utility.getDeviceInfo().browserName, browserVersione: Utility.getDeviceInfo().browserVersion, osName: Utility.getDeviceInfo().osName, osVersione: Utility.getDeviceInfo().osVersion, device: Utility.getDeviceInfo().device, email: resp.body.email, telefono: resp.body.telefono, nome: resp.body.nome, cognome: resp.body.cognome});
					}
				});
			},(resp)=>{
				console.log(resp);
			})
		},(resp)=>{
			console.log(resp);

			this.isChatReady().then(() => {
			// eslint-disable-next-line no-constant-condition,no-undef
				window.$ec.addUserInfo({promozione: Constants.TRACKING_PROMOCODE, pagecode: document.location.href, browserName: Utility.getDeviceInfo().browserName, browserVersione: Utility.getDeviceInfo().browserVersion, osName: Utility.getDeviceInfo().osName, osVersione: Utility.getDeviceInfo().osVersion, device: Utility.getDeviceInfo().device});
			});
		})
	}

	init() {
		this.loadChildComponents(this);
	}
}

export default DefaultCtrl;
